import * as React from 'react';
import cx from 'classnames';
import { Box } from '../../utils/index.js';
export const Backdrop = React.forwardRef((props, ref) => {
  let { isVisible = true, className, ...rest } = props;
  return React.createElement(Box, {
    className: cx(
      'iui-backdrop',
      {
        'iui-backdrop-visible': isVisible,
      },
      className,
    ),
    ref: ref,
    ...rest,
  });
});
Backdrop.displayName = 'Backdrop';
